<template>
  <v-menu
    v-ripple
    bottom
    right
    content-class="dropdown-menu"
    offset-y
    transition="slide-y-transition"
    class="pa-0"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        icon
        class="ma-0 person"
        title="設定"
        v-on="on"
      >
        <v-icon color="tertiary">
          mdi-account
        </v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-list dense>
        <v-list-tile :disabled="true">
          {{ user.name }}さん
        </v-list-tile>
        <v-divider />
        <v-list-tile
          color="metalBlue"
          to="/profile"
        >
          <v-list-tile-title>個人設定</v-list-tile-title>
        </v-list-tile>
        <v-list-tile
          @click="logout"
        >
          <v-list-tile-title>ログアウト</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-card>
  </v-menu>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  computed: {
    ...mapState('app', ['user'])
  },
  methods: {
    ...mapActions('auth', ['logout'])
  }
}
</script>

<style lang="scss" scoped>
.person {
  border-radius: 50%;
  transition: box-shadow .2s ease-out;

  &:hover, &:focus {
    box-shadow: 0px 0px 0px 1px #888 !important;
  }
}
</style>
